const i18n = {
	registrationDateFrom: {
		1 : "Дата регистрации от",
		0 : "Дата рэгістрацыі ад"
	},
	registrationDateTo: {
		1 : "Дата регистрации до",
		0 : "Дата рэгістрацыі да"
	},
	registrationDate: {
		1 : "Дата регистрации",
		0 : "Дата рэгістрацыі"
	},
	blocked: {
		1 : "Заблокирован",
		0 : "Заблакаваны"
	},
	noPosition: {
		1 : "Нету должности",
		0 : "Няма пасады"
	},
	tempExternalAdmin: {
		1 : "Временный внешний администратор",
		0 : "Часовы знешні адміністратар"
	},
	positionName: {
		1 : "Должность",
		0 : "Пасада"
	}
}

export default i18n
